import { PerformanceData } from './types';

export class EventEmitter<T> {
  private listeners: Array<(data: T) => void> = [];

  subscribe(callback: (data: T) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback);
    };
  }

  emit(data: T) {
    this.listeners.forEach((listener) => listener(data));
  }
}

export const performanceDataEmitter = new EventEmitter<PerformanceData>();
